export default __webpack_public_path__ + "static/media/whatsapp-img.17fd543e.svg";